import type {
  PanelSalesInquiryCountsDto,
  PanelSalesInquiryDetailDto,
  PanelSalesInquiryListDto,
  PanelSalesInquiryListQuery,
  SalesInquiryStatus,
} from '@icebreaker/shared';
import { api } from '@/shared/api/client';

/**
 * Satış adayları `api` katmanı — YALNIZCA sagadan çağrılır. Detay okuması
 * kişisel veriye erişimdir ve sunucu her çağrıyı denetim defterine yazar;
 * bu yüzden detay yalnız personel adayı AÇTIĞINDA istenir, önden çekilmez.
 */
export async function fetchSalesInquiries(
  query: PanelSalesInquiryListQuery,
): Promise<PanelSalesInquiryListDto> {
  return await api.panelSales.list({
    status: query.status,
    q: query.q,
    page: query.page,
    pageSize: query.pageSize,
  });
}

/** Yalnız sayılar: kişi yok, sunucu denetim satırı yazmaz (kenar menü rozeti). */
export async function fetchSalesCounts(): Promise<PanelSalesInquiryCountsDto> {
  return await api.panelSales.counts();
}

export async function fetchSalesInquiry(id: string): Promise<PanelSalesInquiryDetailDto> {
  return await api.panelSales.get(id);
}

export async function changeSalesInquiryStatus(input: {
  readonly id: string;
  readonly status: SalesInquiryStatus;
}): Promise<PanelSalesInquiryDetailDto> {
  return await api.panelSales.changeStatus(input.id, { status: input.status });
}
